import { render } from "./Rzrj.vue?vue&type=template&id=bb434eba&scoped=true"
import script from "./Rzrj.vue?vue&type=script&lang=js"
export * from "./Rzrj.vue?vue&type=script&lang=js"

import "./Rzrj.vue?vue&type=style&index=0&id=bb434eba&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bb434eba"

export default script